import styled from "styled-components";

export const Page = styled.div`
  padding: 0px 30px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  header {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.secondary70};
    span {
      display: flex;
      align-items: flex-start;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary100};
    }
    .buttons {
      display: flex;
      align-items: flex-start;
      gap: 15px;
    }
  }
  .content {
    padding: 20px;
    position: relative;
    width: 100%;
    min-height: 200px;
    max-height: 600px;
    background-color: ${({ theme }) => theme.colors.secondary10};
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    margin-top: 7px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .loading{
      width: 100%;
      height: 100%;
    }
    .descriptions {
      flex: 20%;
      display: flex;
      flex-direction: column;
      gap: 40px;
      align-items: end;
      margin-right: 20px;
      font-size: 16px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary100};
    }
    .inputs {
      flex: 80%;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
`;
